/**
 * Labstep
 *
 * @module components/Experiment/Action/Start
 * @desc Action to start experiment
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import { generateNewDateString } from 'labstep-web/services/date.service';
import type React from 'react';
import type { ExperimentActionStartProps } from './types';

export const ExperimentActionStart: React.FC<
  ExperimentActionStartProps
> = ({ experiment, options = {} }) =>
  experiment.canStart ? (
    <EntityActionUpdate
      entityName={experiment.entityName}
      id={experiment.id}
      body={{ started_at: generateNewDateString(), is_ready: true }}
      options={options}
      actionComponentProps={{
        dataCy: 'components/Experiment/Action/Start',
        type: 'button',
        text: 'Start',
        elementProps: {
          color: 'green',
        },
      }}
    />
  ) : null;
